import * as IntegrationDetails from './IntegrationDetails';

export default IntegrationDetails;
